export enum QuestionnaireStorageKeys {
  Upsells = 'upsells',
  AgreementQuestions = 'agreement-questions',
}
